export const developedSoftwares = [
  {
    name: 'INFOGIS',
    desc: 'Multimedia platform',
    details: [
      {
        title: 'Billing module',
        desc: 'Billing system in clients and devices',
      },
      {
        title: 'Middleware module',
        desc: 'Middleware for devices',
      },
      {
        title: 'VOD module',
        desc: 'Module for VOD and SVOD',
      },
      {
        title: 'Cutch up /Time Shift',
        desc: 'Module for recording and playback',
      },
      {
        title: 'API interface',
        desc: 'Module for integration with other platforms',
      },
      {
        title: 'Security',
        desc: 'Session level protection, Token, UUID',
      },
      {
        title: 'APK module',
        desc: 'Module for Android based platform',
      },
      {
        title: 'iOS module',
        desc: 'Module for iOS based platform',
      },
      {
        title: 'WebOS module',
        desc: 'Module for LG WebOS platform',
      },
    ],
  },
  {
    name: 'INFOGIS-ERP',
    desc: 'Billing, ticketing, monitoring and asset management system',
    details: [
      {
        title: 'ERP Billing module',
        desc: 'Billing system in clients and devices',
      },
      {
        title: 'Ticketing module',
        desc: 'Ticketing and calling module',
      },
      {
        title: 'Payment gateway module',
        desc: 'Module for payment processing interconnecting with banking system, and other payment providers',
      },
      {
        title: 'Asset Management Module',
        desc: 'Module for asset management API Interface– integrated with provision system',
      },
    ],
  },
  {
    name: 'INFOGIS PROVISION',
    desc: 'Device provision system',
    details: [
      {
        title: 'Base module',
        desc: 'Billing system in clients and devices',
      },
      {
        title: 'TR-069 module',
        desc: 'CPE WAN Management Protocol (CWMP) module',
      },
      {
        title: ' API interface',
        desc: 'module for integration with billing platforms',
      },
    ],
  },
]
